import React from 'react'

const ContactPanel = () => {
  return (
    <div className='bg-gradient-to-tr from-indigo-700 to-indigo-800 relative text-white'>
      <div className='max-w-2xl mx-auto text-center py-10 sm:py-16 px-8 space-y-6'>
        <h2>We can help</h2>
        <p className='prose prose-lg lg:prose-xl text-indigo-100'>
          As with everything in life, things pan out better when you work together. So if you are looking for a website support, updating a Shopify Theme, a fresh out of the box site or support with
          your Digital Strategy, you've come to the right place. We pride ourselves on our flexibility and honesty.
        </p>
        <a href='/contact/' className='w-full inline-flex items-center justify-center sm:w-auto button'>
          Why not get in touch?
        </a>
      </div>
    </div>
  )
}

export default ContactPanel
